import { render } from "./CollapseItem.vue?vue&type=template&id=71ec1cf1"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"
script.render = render

export default script